import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ptBR from './locales/pt-BR.json';
import enUS from './locales/en-US.json';

// Helper function to get browser language
export const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  // Normalize to our supported languages
  if (browserLang.startsWith('en')) return 'en-US';
  if (browserLang.startsWith('pt')) return 'pt-BR';
  return 'pt-BR'; // Default fallback
};

// Helper function to get current language (respects user preference over browser)
export const getCurrentLanguage = () => {
  return i18n.language || getBrowserLanguage();
};

// Priority: localStorage (logged user preference) > browser detection
const savedLang = localStorage.getItem('systemLanguage');
let initialLanguage;

if (savedLang) {
  // User has a saved preference (logged in user)
  initialLanguage = savedLang === 'en' ? 'en-US' : (savedLang === 'pt' ? 'pt-BR' : savedLang);
} else {
  // No saved preference, detect from browser
  initialLanguage = getBrowserLanguage();
}

// Debug: log adminPanel translation
console.log('AdminPanel PT-BR:', ptBR?.landing?.features?.adminPanel);
console.log('AdminPanel EN-US:', enUS?.landing?.features?.adminPanel);

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': {
        translation: ptBR
      },
      'en-US': {
        translation: enUS
      }
    },
    lng: initialLanguage,
    fallbackLng: 'pt-BR',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
